import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "../..";

export const getEnvironmentStateSelector = createSelector(
  (state: RootState) => state.environmentState,
  (state) => state,
);

export const environmentSelectors = {
  environment: getEnvironmentStateSelector,
};
